import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { Box } from 'reflexbox';
import set from 'set-value';
import BackupIcon from '@material-ui/icons/Backup';

import * as actions from '../../redux/otc';
import DynamicForm from '../DynamicForm/DynamicForm';
import DynamicDialog from '../DynamicDialog/DynamicDialog';
import {
  HorizontalRule, HealtheraButton, PaperContainer
} from '../../healtheraComponents';
import {
  BannerImage, BannerLink, BannerLinkLabel, BannerTitle,
  BannerButton, BannerButtonDelete, FileSelector, FileLabel,
} from '../WhiteLabels/styles';
import { BannerContainer } from './styles';
import { BannerSchema } from '../WhiteLabels/InputSchema';
import { validated } from '../../helpers';
import NotificationPopup from '../NotificationPopup';

function ECommerce() {
  const [bannerImg, setBannerImg] = useState({ files: [] });
  const [bannerImgInput, setBannerImgInput] = useState(null);
  const [bannerValidationArray, setBannerValidationArray] = useState([]);
  const [showAddBannerModal, setShowAddBannerModal] = useState(false);
  const [bannerSchema, setBannerSchema] = useState({});
  const [bannerData, setBannerData] = useState({});
  const [bannerUpdateData, setBannerUpdateData] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const dispatch = useDispatch();
  const { banners, error: bannerError } = useSelector(state => state.otc);

  useEffect(() => {
    dispatch(actions.getBanners());
  }, [dispatch]);

  useEffect(() => {
    bannerError && notify(bannerError);
  }, [bannerError]);

  const openBannerModal = () => {
    setBannerImg({ files: [] });
    setBannerImgInput(null);
    setShowAddBannerModal(true);
  };

  const addBanner = () => {
    setBannerData({});
    setBannerUpdateData({});
    setBannerSchema(BannerSchema());
    openBannerModal();
  };

  const notify = (message) => {
    setNotificationMessage(message);
    setShowNotification(true);
  };

  const editBanner = id => {
    const banner = banners.find(i => i._id === id) || {};
    setBannerData(banner);
    setBannerUpdateData({ id });
    setBannerSchema(BannerSchema(banner));
    openBannerModal();
  };

  const deleteBanner = async id => {
    await dispatch(actions.deleteBanner(id));
    dispatch(actions.getBanners());
  };

  const applyBannerModal = async () => {
    if (!validated(bannerValidationArray)) {
      notify('Can not validate banner form.');
      return;
    }

    const { id, ...body } = bannerUpdateData;
    const fd = new FormData();

    if (bannerImg.files[0]) fd.append('banner_img', bannerImg.files[0]);
    if (body.title) fd.append('title', body.title);
    if (body.link) fd.append('link', body.link);

    if (id) {
      await dispatch(actions.editBanner(id, fd));
    } else {
      await dispatch(actions.addBanner(fd));
    }

    dispatch(actions.getBanners());
    setShowAddBannerModal(false);
  };

  const onChangeBannerData = ({ field, value, validation }) => {
    set(bannerValidationArray, field, validation);
    set(bannerUpdateData, field, value);
    setBannerValidationArray(bannerValidationArray);
    setBannerUpdateData(bannerUpdateData);
  };

  const onChangeFile = (callback, value) => {
    try {
      if (value.files[0]) {
        if (value.files[0].size < 15000000) {
          callback(value);
        } else {
          alert('image size is too big');
        }
      }
    } catch (e) { }
  };

  const closeBannerModal = () => setShowAddBannerModal(false);

  const renderBannerModal = () => {
    const actions = (
      <>
      <HealtheraButton onClick={closeBannerModal} margin={'0 10px 5px'} height={'32px'} width={'95px'} color="primary">
        Cancel
      </HealtheraButton>
      <HealtheraButton onClick={applyBannerModal} margin={'0 10px 5px'} height={'32px'}  width={'95px'} >
        Update
      </HealtheraButton>
      </>
    );

    const modalContent = (
      <>
      <Box style={{ textAlign: 'center' }}>
        {bannerData && bannerData.url && (
          <Box>
            <BannerImage src={bannerData.url} />
          </Box>
        )}
        <FileSelector
          type='file'
          name='banner_img'
          id='banner_img'
          ref={ref => setBannerImgInput(ref)}
          onChange={() => onChangeFile(setBannerImg, bannerImgInput)}
          accept="image/png, image/jpeg"
        />
        <FileLabel htmlFor='banner_img'>
          {(bannerImg.files[0] || { name: <>Choose a banner image <BackupIcon /></> }).name}
        </FileLabel>
      </Box>
      <DynamicForm
        onChange={onChangeBannerData}
        fields={bannerSchema.banners}
      />
      </>
    );

    return (
      <DynamicDialog
        open={showAddBannerModal}
        title="Marketing Banner"
        field={modalContent}
        actions={actions}
      />
    );
  };

  return (
    <BannerContainer>
      <PaperContainer>
        <NotificationPopup
          isOpen={showNotification}
          onClose={() => setShowNotification(false)}
          message={notificationMessage}
        />
        {banners && banners.length > 0 && (
          <>
          {banners.map(banner => {
            const { title, _id, url, link } = banner;
            return (
              <Box style={{ width: '100%' }} key={_id}>
                <BannerImage src={url} />
                <BannerTitle>{title}</BannerTitle>
                <Box>
                  <BannerLinkLabel>External link:</BannerLinkLabel>
                  <BannerLink href={link} target="_blank" >{link}</BannerLink>
                </Box>
                <Box>
                  <BannerButton onClick={() => editBanner(_id)}>Edit</BannerButton>
                  <span style={{ margin: '0 15px' }}>|</span>
                  <BannerButtonDelete onClick={() => deleteBanner(_id)}>Delete</BannerButtonDelete>
                </Box>
                <HorizontalRule style={{ margin: '20px 0' }} width="95%" />
              </Box>
            );
          })}
          </>
        )}
        <HealtheraButton onClick={addBanner}>Add another banner</HealtheraButton>
        {renderBannerModal()}
      </PaperContainer>
    </BannerContainer>
  );
}

export default withRouter(ECommerce);
